var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-275.38V-640q0-73.15 74.23-95.46 74.23-22.31 184.23-24.54l30-60H283.08v-35.39h393.84V-820H531.54l-30 60q112.08 2.23 185.27 24.42Q760-713.38 760-640v364.62q0 48.23-33.58 81.8Q692.85-160 644.62-160l60 60v20h-33.85l-80-80H369.23l-80 80h-33.85v-20l60-60q-48.23 0-81.8-33.58Q200-227.15 200-275.38ZM644.62-400H240h480-75.38ZM511.73-268.27q12.89-12.88 12.89-31.73t-12.89-31.73q-12.88-12.89-31.73-12.89t-31.73 12.89q-12.89 12.88-12.89 31.73t12.89 31.73q12.88 12.89 31.73 12.89t31.73-12.89Zm-32.19-390.19h237.23-473.08H479.54ZM240-440h480v-178.46H240V-440Zm75.38 240h329.24Q676-200 698-222q22-22 22-53.38V-400H240v124.62Q240-244 262-222q22 22 53.38 22Zm164.16-520q-124 0-175.08 16.04-51.08 16.04-60.77 45.5h473.08q-9.69-30.16-61.23-45.85Q604-720 479.54-720Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.dc0d82c16dc5ccdf9b35f24d88a66b07.svg";
export { ForwardRef as ReactComponent };